/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
          <vs-button :color="sel==='r3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r3'">R3</vs-button>
          <vs-button :color="sel==='sw101'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw101'">Sw101</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Enable OSPF 110 area 0 per interface</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/8</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="dev in task1Devices" :key="'t1-'+dev.key" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ dev.label }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in dev.items" :key="'t1-'+dev.key+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(dev.key)[item.key])"></div>
                    <code class="text-base" :class="getComp(dev.key)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
              <p class="text-xs mt-1 ml-1" style="color:#6b7280">Verify: <code>show ip ospf neighbor</code> on Sw101</p>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Set OSPF priorities — R1 DR, Sw101 BDR</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/5</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="dev in task2Devices" :key="'t2-'+dev.key" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ dev.label }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in dev.items" :key="'t2-'+dev.key+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(dev.key)[item.key])"></div>
                    <code class="text-base" :class="getComp(dev.key)[item.key]?'text-success':''">{{ item.label }}</code>
                  </div>
                </div>
              </div>
              <p class="text-xs mt-1 ml-1" style="color:#6b7280">Verify: <code>show ip ospf neighbor</code> on R1</p>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ saveProgress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="dk in ['r1','r2','r3','sw101']" :key="'s-'+dk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devLabel(dk) }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(dk).saved)"></div>
                    <code class="text-base" :class="getComp(dk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'"    key="r1"    id="r1_terminal"    :commands="r1Commands"    :prompt="r1Prompt"    :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'"    key="r2"    id="r2_terminal"    :commands="r2Commands"    :prompt="r2Prompt"    :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
          <vue-command v-show="sel==='r3'"    key="r3"    id="r3_terminal"    :commands="r3Commands"    :prompt="r3Prompt"    :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R3" />
          <vue-command v-show="sel==='sw101'" key="sw101" id="sw101_terminal" :commands="sw101Commands" :prompt="sw101Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw101" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "show ip ospf neighbor" to verify adjacencies.';

const mkCommands = (rk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(rk),
  configure:  (x) => vm.iosConfigure(rk, x),
  conf:       (x) => vm.iosConfigure(rk, x),
  interface:  (x) => vm.iosInterface(rk, x),
  int:        (x) => vm.iosInterface(rk, x),
  ip:         (x) => vm.iosIp(rk, x),
  clear:      (x) => vm.iosClear(rk, x),
  do:         (x) => vm.iosDo(rk, x),
  show:       (x) => vm.iosShow(rk, x),
  exit:       () => vm.iosExit(rk),
  end:        () => vm.iosEnd(rk),
  copy:       (x) => vm.iosCopy(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/OSPF_Configuration_Sim2.png',
      sel: 'r1',
      totalScore: 0,

      r1:    { mode: 'exec', currentIf: null },
      r2:    { mode: 'exec', currentIf: null },
      r3:    { mode: 'exec', currentIf: null },
      sw101: { mode: 'exec', currentIf: null },

      // r1(4) + r2(4) + r3(4) + sw101(5) = 17 total keys
      r1Completion:    { e02If: false, e02Ospf: false, e02OspfPri: false, saved: false },
      r2Completion:    { e01If: false, e01Ospf: false, e01OspfPri: false, saved: false },
      r3Completion:    { e00If: false, e00Ospf: false, e00OspfPri: false, saved: false },
      sw101Completion: { vlan101If: false, vlan101Ospf: false, vlan101OspfPri: false, clearOspf: false, saved: false },

      r1Commands: null, r2Commands: null, r3Commands: null, sw101Commands: null,

      task1Devices: [
        { key: 'r1',    label: 'R1',    items: [{ key: 'e02If',      label: 'interface e0/2'   }, { key: 'e02Ospf',      label: 'ip ospf 110 area 0' }] },
        { key: 'r2',    label: 'R2',    items: [{ key: 'e01If',      label: 'interface e0/1'   }, { key: 'e01Ospf',      label: 'ip ospf 110 area 0' }] },
        { key: 'r3',    label: 'R3',    items: [{ key: 'e00If',      label: 'interface e0/0'   }, { key: 'e00Ospf',      label: 'ip ospf 110 area 0' }] },
        { key: 'sw101', label: 'Sw101', items: [{ key: 'vlan101If',  label: 'interface vlan101'}, { key: 'vlan101Ospf',  label: 'ip ospf 110 area 0' }] },
      ],
      task2Devices: [
        { key: 'r1',    label: 'R1',    items: [{ key: 'e02OspfPri',      label: 'ip ospf priority 255' }] },
        { key: 'sw101', label: 'Sw101', items: [{ key: 'vlan101OspfPri',  label: 'ip ospf priority 254' }, { key: 'clearOspf', label: 'clear ip ospf process' }] },
        { key: 'r2',    label: 'R2',    items: [{ key: 'e01OspfPri',      label: 'ip ospf priority 0' }] },
        { key: 'r3',    label: 'R3',    items: [{ key: 'e00OspfPri',      label: 'ip ospf priority 0' }] },
      ],
    };
  },

  computed: {
    r1Prompt()    { const m = this.r1.mode;    return m==='config-if'?'R1(config-if)#':m==='config'?'R1(config)#':'R1#'; },
    r2Prompt()    { const m = this.r2.mode;    return m==='config-if'?'R2(config-if)#':m==='config'?'R2(config)#':'R2#'; },
    r3Prompt()    { const m = this.r3.mode;    return m==='config-if'?'R3(config-if)#':m==='config'?'R3(config)#':'R3#'; },
    sw101Prompt() { const m = this.sw101.mode; return m==='config-if'?'Sw101(config-if)#':m==='config'?'Sw101(config)#':'Sw101#'; },

    task1Progress() {
      const c1=this.r1Completion, c2=this.r2Completion, c3=this.r3Completion, cs=this.sw101Completion;
      return [c1.e02If,c1.e02Ospf, c2.e01If,c2.e01Ospf, c3.e00If,c3.e00Ospf, cs.vlan101If,cs.vlan101Ospf].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 8; },

    task2Progress() {
      const c1=this.r1Completion, c2=this.r2Completion, c3=this.r3Completion, cs=this.sw101Completion;
      return [c1.e02OspfPri, cs.vlan101OspfPri, cs.clearOspf, c2.e01OspfPri, c3.e00OspfPri].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 5; },

    saveProgress() {
      return [this.r1Completion.saved, this.r2Completion.saved, this.r3Completion.saved, this.sw101Completion.saved].filter(Boolean).length;
    },
    saveDone() { return this.saveProgress === 4; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands    = mkCommands('r1', this);
    this.r2Commands    = mkCommands('r2', this);
    this.r3Commands    = mkCommands('r3', this);
    this.sw101Commands = mkCommands('sw101', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    devLabel(k) { return { r1:'R1', r2:'R2', r3:'R3', sw101:'Sw101' }[k] || k; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      let s = (ifStr || '').toLowerCase()
        .replace(/^gigabitethernet/, '')
        .replace(/^fastethernet/, '')
        .replace(/^ethernet/, '')
        .replace(/^gi(?=\d)/, '')
        .replace(/^fa(?=\d)/, '')
        .replace(/^e(?=\d)/, '')
        .replace(/^g(?=\d)/, '')
        .trim();
      return s;
    },

    updateScore() {
      let score = 0;
      [this.r1Completion, this.r2Completion, this.r3Completion, this.sw101Completion].forEach(c =>
        Object.values(c).forEach(v => { if (v) score++; })
      );
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 17) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosConfigure(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        s.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      const s = this[rk];
      if (s.mode === 'config-if') { s.mode = 'config'; s.currentIf = null; }
      else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },

    iosEnd(rk) { this[rk].mode = 'exec'; this[rk].currentIf = null; return createStdout(''); },

    iosInterface(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      let ifArg = String(x._[1] || '');
      // Handle "vlan 101" (space-separated) → "vlan101"
      if (ifArg.toLowerCase() === 'vlan' && x._[2]) ifArg = 'vlan' + x._[2];
      const ifNorm = this.normalizeIf(ifArg) || ifArg.toLowerCase();

      s.mode = 'config-if';
      s.currentIf = ifNorm;

      const c = this[rk + 'Completion'];
      if (rk === 'r1'    && ifNorm === '0/2'      && !c.e02If)      { c.e02If      = true; this.updateScore(); }
      if (rk === 'r2'    && ifNorm === '0/1'      && !c.e01If)      { c.e01If      = true; this.updateScore(); }
      if (rk === 'r3'    && ifNorm === '0/0'      && !c.e00If)      { c.e00If      = true; this.updateScore(); }
      if (rk === 'sw101' && ifNorm === 'vlan101'  && !c.vlan101If)  { c.vlan101If  = true; this.updateScore(); }

      return createStdout('');
    },

    iosIp(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      if ((x._[1] || '').toLowerCase() !== 'ospf') return createStderr('% Invalid input detected');

      const sub2 = (x._[2] || '').toLowerCase();
      const c    = this[rk + 'Completion'];
      const ifn  = s.currentIf;

      // ip ospf priority <value>
      if (sub2 === 'priority') {
        const pri = String(x._[3] || '');
        if (rk === 'r1' && ifn === '0/2' && pri === '255' && !c.e02OspfPri) {
          c.e02OspfPri = true; this.updateScore();
          return createStdout(this.guide(
            'R1 OSPF priority set to 255 (maximum). In a DR election, the router with the highest priority wins — R1 will always become the DR on this multi-access segment. ' +
            'A priority of 0 means the router never becomes DR or BDR. ' +
            '→ Set Sw101 priority to 254: "ip ospf priority 254" on Sw101\'s Vlan101 interface.'
          ));
        }
        if (rk === 'sw101' && ifn === 'vlan101' && pri === '254' && !c.vlan101OspfPri) {
          c.vlan101OspfPri = true; this.updateScore();
          return createStdout(this.guide(
            'Sw101 OSPF priority set to 254. Since R1 has priority 255 (DR) and Sw101 has 254, Sw101 will always become BDR whenever R1 is present. ' +
            '→ Set R2\'s priority to 0: "ip ospf priority 0" on R2\'s E0/1 interface.'
          ));
        }
        if (rk === 'r2' && ifn === '0/1' && pri === '0' && !c.e01OspfPri) {
          c.e01OspfPri = true; this.updateScore();
          return createStdout(this.guide(
            'R2 OSPF priority set to 0. A router with priority 0 never participates in DR/BDR elections — it will always remain a DROTHER regardless of router ID. ' +
            '→ Set R3\'s priority to 0.'
          ));
        }
        if (rk === 'r3' && ifn === '0/0' && pri === '0' && !c.e00OspfPri) {
          c.e00OspfPri = true; this.updateScore();
          return createStdout(this.guide(
            'R3 OSPF priority set to 0. R3 is also excluded from DR/BDR elections. ' +
            '→ On Sw101: type "end" to reach exec mode, then "clear ip ospf process" and confirm with y to trigger a new election.'
          ));
        }
        return createStdout('');
      }

      // ip ospf <process-id> area <area-id>
      const processId = sub2;
      const areaKw    = (x._[3] || '').toLowerCase();
      const areaId    = String(x._[4] || '');

      if (processId !== '110' || areaKw !== 'area' || areaId !== '0') return createStdout('');

      if (rk === 'r1' && ifn === '0/2' && !c.e02Ospf) {
        c.e02Ospf = true; this.updateScore();
        return createStdout(this.guide(
          'OSPF process 110, area 0 enabled directly on R1 e0/2. Using "ip ospf" on the interface (instead of the "network" command under the OSPF process) is cleaner — it binds OSPF exactly to this interface without needing to calculate wildcard masks. ' +
          '→ Configure R2: "interface e0/1" then "ip ospf 110 area 0".'
        ));
      }
      if (rk === 'r2' && ifn === '0/1' && !c.e01Ospf) {
        c.e01Ospf = true; this.updateScore();
        return createStdout(this.guide('OSPF process 110, area 0 enabled on R2 e0/1. → Configure R3: "interface e0/0" then "ip ospf 110 area 0".'));
      }
      if (rk === 'r3' && ifn === '0/0' && !c.e00Ospf) {
        c.e00Ospf = true; this.updateScore();
        return createStdout(this.guide('OSPF process 110, area 0 enabled on R3 e0/0. → Configure Sw101: "interface vlan101" then "ip ospf 110 area 0".'));
      }
      if (rk === 'sw101' && ifn === 'vlan101' && !c.vlan101Ospf) {
        c.vlan101Ospf = true; this.updateScore();
        return createStdout(this.guide(
          'OSPF process 110, area 0 enabled on Sw101 Vlan101. All four devices are now in OSPF area 0 — adjacencies will form on the 10.101.101.0/24 segment. ' +
          'Verify: "show ip ospf neighbor" on Sw101 should list all three routers. ' +
          '→ Configure Task 2: OSPF priorities starting with R1 "ip ospf priority 255".'
        ));
      }

      return createStdout('');
    },

    iosClear(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      if ((x._[1]||'').toLowerCase()==='ip' && (x._[2]||'').toLowerCase()==='ospf' && (x._[3]||'').toLowerCase()==='process') {
        const c = this[rk + 'Completion'];
        if (rk === 'sw101' && !c.clearOspf) { c.clearOspf = true; this.updateScore(); }
        return createStdout(
          'Reset ALL OSPF processes? [no]: y<br>% OSPF: Clearing process ...' +
          this.guide(
            'OSPF processes cleared on Sw101. All routers drop existing adjacencies and re-elect DR/BDR using the new priorities. ' +
            'After reconvergence: R1 (priority 255) becomes DR, Sw101 (priority 254) becomes BDR, R2 and R3 (priority 0) become DROTHER. ' +
            '→ Verify: switch to R1 and run "show ip ospf neighbor".'
          )
        );
      }
      return createStderr('% Invalid input detected');
    },

    iosDo(rk, x) {
      // Allow exec commands from config modes via "do"
      const sub1 = (x._[1] || '').toLowerCase();
      if (sub1 === 'clear') {
        const fakeX = { _: ['clear'].concat(x._.slice(2)) };
        const orig = this[rk].mode;
        this[rk].mode = 'exec';
        const result = this.iosClear(rk, fakeX);
        this[rk].mode = orig;
        return result;
      }
      if (sub1 === 'show') {
        const fakeX = { _: ['show'].concat(x._.slice(2)) };
        return this.iosShow(rk, fakeX);
      }
      return createStderr('% Invalid input detected');
    },

    iosShow(rk, x) {
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const sub3 = (x._[3] || '').toLowerCase();

      if (sub1 === 'ip' && sub2 === 'ospf' && sub3 === 'neighbor') {
        const c1=this.r1Completion, c2=this.r2Completion, c3=this.r3Completion, cs=this.sw101Completion;
        const task1Complete = c1.e02Ospf && c2.e01Ospf && c3.e00Ospf && cs.vlan101Ospf;
        const task2Complete = c1.e02OspfPri && c2.e01OspfPri && c3.e00OspfPri && cs.vlan101OspfPri && cs.clearOspf;
        const hdr = 'Neighbor ID&nbsp;&nbsp;Pri&nbsp;&nbsp;State&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dead Time&nbsp;&nbsp;Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Interface<br>';

        if (!task1Complete) {
          return createStdout(hdr + this.guide('No OSPF neighbors yet — complete Task 1 on all four devices first.'));
        }

        // Task 1 done — initial election (all pri=1)
        if (!task2Complete) {
          if (rk === 'sw101') {
            return createStdout(hdr +
              '10.3.3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;FULL/BDR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;00:00:36&nbsp;&nbsp;&nbsp;10.101.101.3&nbsp;&nbsp;&nbsp;Vlan101<br>' +
              '10.1.1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;FULL/DROTHER&nbsp;&nbsp;&nbsp;&nbsp;00:00:30&nbsp;&nbsp;&nbsp;10.101.101.1&nbsp;&nbsp;&nbsp;Vlan101<br>' +
              '10.2.2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;FULL/DROTHER&nbsp;&nbsp;&nbsp;&nbsp;00:00:32&nbsp;&nbsp;&nbsp;10.101.101.2&nbsp;&nbsp;&nbsp;Vlan101' +
              this.guide('All three routers are neighbors. DR elected by highest router-ID (before priority tuning). → Configure Task 2 priorities.')
            );
          }
          return createStdout(hdr + '(Complete Task 2 and run "clear ip ospf process" on Sw101 to see updated DR/BDR state.)');
        }

        // Task 2 done — R1 is DR, Sw101 is BDR
        if (rk === 'r1') {
          return createStdout(hdr +
            '10.2.2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0&nbsp;&nbsp;&nbsp;&nbsp;FULL/DROTHER&nbsp;&nbsp;&nbsp;&nbsp;00:00:36&nbsp;&nbsp;&nbsp;10.101.101.2&nbsp;&nbsp;&nbsp;Vlan101<br>' +
            '10.3.3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0&nbsp;&nbsp;&nbsp;&nbsp;FULL/DROTHER&nbsp;&nbsp;&nbsp;&nbsp;00:00:30&nbsp;&nbsp;&nbsp;10.101.101.3&nbsp;&nbsp;&nbsp;Vlan101<br>' +
            '10.1.1.1&nbsp;&nbsp;&nbsp;&nbsp;255&nbsp;&nbsp;&nbsp;FULL/DR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;00:00:35&nbsp;&nbsp;&nbsp;10.101.101.1&nbsp;&nbsp;&nbsp;Vlan101' +
            this.guide('R1 (10.1.1.1, pri 255) is DR. R2 and R3 (pri 0) are DROTHER — Sw101 (pri 254) is BDR by deduction. → Save all devices.')
          );
        }
        return createStdout(hdr + '(Use R1 to verify final DR/BDR state after clearing OSPF on Sw101.)');
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[rk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(
            `${this.devLabel(rk)} configuration saved to NVRAM. ` +
            (this.saveDone ? '✓ All devices saved — simulation complete!' : '→ Save the remaining devices.')
          )
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal, #r3_terminal, #sw101_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

